import { Form, Formik, useFormikContext } from 'formik'
import { Button } from 'blaze-ui/Button'
import { CampaignFormHandle, CreateCampaignFormValues, CreateCampaignProps } from './Types'
import * as yup from 'yup'
import { ThemeInput } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/ThemeInput'
import Styles from './CreateCampaign.module.scss'
import { TargetLinkInput } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/TargetLinkInput'
import { Sources } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/Sources'
import { Schedule } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/Schedule'
import { forwardRef, useImperativeHandle } from 'react'
import { ModalSubmitContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'

const validationScheme = yup.object().shape({
  topic: yup.string().required('Please enter a theme/topic for the campaign'),
})

const CampaignForm = forwardRef<CampaignFormHandle, {}>((_, ref) => {
  const formikContext = useFormikContext<CreateCampaignFormValues>()
  useImperativeHandle(ref, () => formikContext)
  const { submitForm, isSubmitting } = formikContext
  return (
    <Form className={Styles.form}>
      <ThemeInput name="topic" />
      <TargetLinkInput name="targetLink" />
      <Schedule />
      <Sources />
      <ModalSubmitContainer>
        <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
          Continue
        </Button>
      </ModalSubmitContainer>
    </Form>
  )
})

export const CreateCampaign = forwardRef<CampaignFormHandle, CreateCampaignProps>(
  ({ startDate, onNext, topic, length, targetLink, anchorContent, sources }, ref) => {
    return (
      <Formik
        validationSchema={validationScheme}
        initialValues={{
          topic,
          startDate,
          length,
          targetLink,
          anchorContent,
          sources,
        }}
        onSubmit={(values) => onNext(values)}
      >
        <CampaignForm ref={ref} />
      </Formik>
    )
  },
)
